<template>
  <BasePopupModal :modal="modal" :overlay-color="'white'" :width="900">
    <div class="change-item-modal">
      <div class="change-item-modal--header font-weight-light">
        {{ $t(`modals.section.${modalType}.title`) }}
      </div>
      <div class="change-item-modal--content">
        <div class="change-item-modal--content-input d-flex justify-center">
          <v-form class="change-item-modal--content-input-form">
            <v-container>
              <v-text-field v-model="formData.name" :label="'Zones'" :rules="stringRules" outline />
              <v-text-field v-model="formData.alias" :label="'Alias'" maxlength="5" :rules="stringRules" outline />
            </v-container>
          </v-form>
        </div>
      </div>
      <div class="change-item-modal--buttons d-flex justify-end">
        <v-btn class="change-item-modal--buttons-cancel" outlined depressed @click="close"> Annuler </v-btn>
        <v-btn class="change-item-modal--buttons-save" color="#38BB00" :disabled="isDisabled" dark depressed @click="submit"> Valider </v-btn>
      </div>
    </div>
  </BasePopupModal>
</template>

<script>
import { cloneDeep } from 'lodash';

import BasePopupModal from '@/components/modals/base/BasePopupModal';

export default {
  name: 'ChangeSectionModal',
  components: {
    BasePopupModal
  },
  props: {
    modal: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      formData: {
        name: '',
        alias: '',
        antipassback: false
      },
      type: 1
    };
  },
  computed: {
    title() {
      return this.modal.payload.text.title;
    },
    oldValues() {
      return this.modal.payload.oldValues;
    },
    modalType() {
      const modal = ['edit', 'new'];
      return modal[this.type];
    },
    stringRules() {
      return [v => this.validateString(v) || 'Valeur invalide'];
    },
    isDisabled() {
      const disabled = this.validateString(this.formData.name);

      return !disabled;
    }
  },
  mounted() {
    if (this.oldValues) {
      this.type = 0;
      this.formData = cloneDeep(this.oldValues);
    }
  },
  beforeDestroy() {
    this.close();
  },
  methods: {
    validateString(value) {
      return !!value.match(/^[a-z0-9 `!@#$%^&*()_+\-=\\[\]{};':"\\|,.<>\\/?~àâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ]*$/i) && value.length > 0 && value.length < 51;
    },
    close() {
      this.$emit('close');
    },
    async submit() {
      if (this.modal.payload.submit) {
        await this.modal.payload.submit({
          name: this.formData.name,
          alias: this.formData.alias,
          antipassback: this.formData.antipassback
        });

        this.close();
      }
    }
  }
};
</script>

<style lang="scss">
.modals-container {
  border: 1px solid #ffffff;
}

.change-item-modal {
  &--header {
    text-align: center;
  }

  .theme--dark.v-btn.v-btn--disabled.v-btn--has-bg {
    background-color: rgb(56, 187, 0, 0.6) !important;
    border-color: rgb(56, 187, 0, 0.6) !important;
  }

  .theme--light.v-text-field--filled > .v-input__control > .v-input__slot {
    background-color: white !important;
  }

  &--content {
    text-align: center;
    margin-top: 10px;
    height: 490px;
    border: 1px solid #e4e6e8;
    border-radius: 10px;

    &-radio-label {
      margin-right: 10px;
    }

    &-label {
      font-size: 18px;
      margin-top: 66px;
      text-align: center;
    }

    &-input {
      margin-top: 69px;

      &-form {
        width: 70%;

        .v-input__slot {
          padding-left: 0 !important;
        }
      }

      label {
        font-size: 12px;
        font-weight: 400;
      }

      input {
        font-weight: 700;
      }
    }
  }

  &--buttons {
    margin-top: 10px;
    margin-bottom: 20px;
    width: 100%;

    button {
      padding: 10px 0 10px;
      height: 38px;
      width: 121px;
      border-radius: 10px;
      font-size: 14px;
      border: 1px solid #e2e2ea;
      font-weight: 600;
      font-size: 14px;
      text-transform: none;
    }

    &-cancel {
      margin-right: 8px;
      color: #696974 !important;
    }
  }
}
</style>
